import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_651 implements Validator {

    public static id = 'CTRL_651';
    private message = 'error.ctr_651';


    public LOG: LogService = new LogService(CTRL_651);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_651.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                let numLotMarche = rg.substr(rg.length - 1);
                const firstChamp = ctrl.value.rgCtrls.firstChamp.replace('INDEX_651_1', numLotMarche);
                const secondChamp = ctrl.value.rgCtrls.secondChamp.replace('INDEX_651_1', numLotMarche);
                const thirdChamp = ctrl.value.rgCtrls.thirdChamp.replace('INDEX_651_1', numLotMarche);
                const fourthChamp = ctrl.value.rgCtrls.fourthChamp.replace('INDEX_651_1', numLotMarche);

                const firstChampNameWithStepId = map.get(firstChamp);
                const secondChampNameWithStepId = map.get(secondChamp);
                const thirdChampNameWithStepId = map.get(thirdChamp);
                const fourthChampNameWithStepId = map.get(fourthChamp);

                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];
                const thirdChampCtrl = form.controls[thirdChampNameWithStepId];
                const fourthChampCtrl = form.controls[fourthChampNameWithStepId];

                const firstEmpty = firstChampCtrl == undefined || firstChampCtrl == null || firstChampCtrl.value == null || firstChampCtrl.value == false;
                const secondEmpty = secondChampCtrl == undefined || secondChampCtrl == null || secondChampCtrl.value == null || secondChampCtrl.value == '' || secondChampCtrl.value == '0';
                const thirdEmpty = thirdChampCtrl == undefined || thirdChampCtrl == null || thirdChampCtrl.value == null || thirdChampCtrl.value == '' || thirdChampCtrl.value == '0';
                const fourthEmpty = fourthChampCtrl == undefined || fourthChampCtrl == null || fourthChampCtrl.value == null || fourthChampCtrl.value == '';

                if (this.isXorOfThree(!firstEmpty, !secondEmpty, !thirdEmpty, !fourthEmpty)) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }

    isXorOfThree(a, b, c, d) {
        return a && !(b || c || d) || b && !(a || c || d) || (c && d) && !(a || b);
    }
}